import axios from "../axios";

export const createTask = (data) => {
  return axios.post("/api/Task/Assign", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get Task 
// Harshada Bhavsar
export const getTask = async (status) => {
  return axios.get(`/api/Task/GetTasks/${status}`);
};


// In-progress Task 
// Harshada Bhavsar - 29/11/2025
export const InProgressTask = (data) => {
  return axios.post("/api/Task/MarkInProgress", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Completed Task 
// Harshada Bhavsar - 29/11/2025
export const CompletedTask = (data) => {
  return axios.post("/api/Task/MarkCompleted", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Reopen Task 
// Harshada Bhavsar - 29/11/2025
export const ReopenTask = (data) => {
  return axios.post("/api/Task/Reopen", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Closed Task 
// Harshada Bhavsar - 29/11/2025
export const ClosedTask = (data) => {
  return axios.post("/api/Task/Close", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Hold Task 
// Harshada Bhavsar - 29/11/2025
export const HoldTask = (data) => {
  return axios.post("/api/Task/Hold", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Resume Task 
// Harshada Bhavsar - 29/11/2025
export const ResumeTask = (data) => {
  return axios.post("/api/Task/Resume", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// GET Task History
//Harshada Bhavsar - 01/12/2025
export const getTaskHistory = (taskNo) => {
  return axios.get(`/api/Task/History/${taskNo}`);
};

// Mark Viewed Task
//Harshada Bhavsar - 04/12/2025
export const MarkViewedTask = (TaskUID) => {
  return axios.get(`/api/Task/MarkViewed/${TaskUID}`);
};


// Re-assign Task 
// Harshada Bhavsar - 09/12/2025
export const ReassignTask = (data) => {
  return axios.post("/api/Task/ReAssign", data, {
    headers: { "Content-Type": "application/json" },
  });
};


// Get Created Task 
// Harshada Bhavsar
export const getCreatedTask = async (status) => {
  return axios.get(`/api/Task/GetCreatedTasks/${status}`);
};

// Get Closed Task 
// Harshada Bhavsar - (17/12/2025)
export const getClosedTask = async () => {
  return axios.get("/api/Task/ClosedTasks");
};

// Edit Task 
// Harshada Bhavsar - (17/12/2025)
export const EditTask = (data) => {
  return axios.post("/api/Task/EditTask", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Invalid Task 
// Harshada Bhavsar - 31/12/2025
export const InvalidTask = (data) => {
  return axios.post("/api/Task/MarkInvalid", data, {
    headers: { "Content-Type": "application/json" },
  });
};

// Get UserBandwidth (02/01/2026)
// Harshada Bhavsar
export const GetUserBandwidth = async (UserUID) => {
  return axios.get(`/api/Developer/UserBandWidth/${UserUID}`);
};


export const TaskRestructure = (data) => {
  return axios.post("/api/Task/TaskRestructure", data, {
    headers: { "Content-Type": "application/json" },
  });
};